import { useMutation, useQuery } from "@tanstack/react-query";
import Api from "../../features/one-query/services/ApiServices";
import { useAppDispatch } from "../hooks";
import { ModelsNamesCompany, ParameterTypes } from "../../Helper";
import {
  applyParameterOnAllModels,
  setParameterForModel,
  updateSuccessPopupSavingState,
} from "../one-query/modelsettings";
import { setFileError, setSnackBarAlert } from "../one-query/chatsSlice";
// GetDefaultSettings
const getModelSettingsParameter = async () => {
  try {
    const response = await Api.get("ModelSetting/ResetDefaultSettings");
    return response.data;
  } catch (e) {}
};

export const useGetModelSettingsParameter = () => {
  return useQuery({
    queryKey: ["GetAllDefaultParameters"],
    queryFn: getModelSettingsParameter, 
  });
};

// Get Default For Model
const getModelSettingParameterForModel = async ({
  modelName,
  modelTitle,
  modelId,
}: {
  modelName: string;
  modelTitle: string;
  modelId:string;
}) => {
  try {
    const response = await Api.get(
      `ModelSetting/GetDefaultSettingsForModel?modelName=${modelName}&modelTitle=${modelTitle}&modelId=${modelId}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const useGetModelSettingParameterForModel = () => {
  return useMutation({
    mutationKey: ["GetDefaultParameterForModel"],
    mutationFn: getModelSettingParameterForModel,
  });
};

export const useGetDefaultParameterForModel = () => {
  const getModelSettingMutation = useGetModelSettingParameterForModel();
  const dispatch = useAppDispatch();
  const GetModelSettingDefaultForModel = (
    modelName: string,
    modelTitle: string,
    modelId:string 
  ) => {
    getModelSettingMutation.mutate(
      { modelName, modelTitle, modelId },
      {
        onSuccess: (data: any) => {
          data?.settingsItems?.forEach((obj: any) => {
            const key =
              ModelsNamesCompany[obj?.modelName.toLowerCase()] +
              " & " +
              obj.modelTitle;
            const parameterValues: ParameterTypes = {
              temperature: obj?.temperature,
              temperatureCurrentValue: obj?.temperatureCurrentValue,
              temperatureMaxValue: obj?.temperatureMaxValue,
              temperatureMinValue: obj?.temperatureMinValue,
              maxToken: obj?.maxToken,
              maxTokenCurrentValue: obj?.maxTokenCurrentValue,
              maxTokenMaxValue: obj?.maxTokenMaxValue,
              maxTokenMinValue: obj?.maxTokenMinValue,
              topP: obj?.topP,
              topPCurrentValue: obj?.topPCurrentValue,
              topPMaxValue: obj?.topPMaxValue,
              topPMinValue: obj?.topPMinValue,
              frequency: obj?.frequency,
              frequencyCurrentValue: obj?.frequencyCurrentValue,
              frequencyMaxValue: obj?.frequencyMaxValue,
              frequencyMinValue: obj?.frequencyMinValue,
              presencePenalty: obj?.presencePenalty,
              presencePenaltyCurrentValue: obj?.presencePenaltyCurrentValue,
              presencePenaltyMaxValue: obj?.presencePenaltyMaxValue,
              presencePenaltyMinValue: obj?.presencePenaltyMinValue,
            };
            dispatch(setParameterForModel({ key, value: parameterValues }));
          });
        },
        onError: (error) => {},
      }
    );
  };

  return GetModelSettingDefaultForModel;
};

//Update Model settings parameter to save in BE
const UpdateModelSettingsParameter = async ({
  modelId,
  selectedModel,
  applyToAll,
  defaultTemperature,
  defaultMaxToken,
  defaultTopP,
  defaultFrequency,
  defaultPresencePenalty,
}: {
  modelId: string;
  selectedModel: string;
  applyToAll: boolean;
  defaultTemperature: number;
  defaultMaxToken: number;
  defaultTopP: number;
  defaultFrequency: number;
  defaultPresencePenalty: number;
}) => {
  const response = await Api.post(
    "ModelSetting/UpdateModelSettings",
    JSON.stringify({
      modelId,
      applyToAll,
      defaultTemperature,
      defaultMaxToken,
      defaultTopP,
      defaultFrequency,
      defaultPresencePenalty,
    })
  );
  return response.data;
};

const useUpdateModelSettingsParameter = () => {
  return useMutation({
    mutationKey: ["UpdateParameters"],
    mutationFn: UpdateModelSettingsParameter,
  });
};

export const useUpadteAllDefaultParameters = () => {
  const updateModelSettingsMutation = useUpdateModelSettingsParameter();
  const dispatch = useAppDispatch();
  const UpdateModelSettingsDefault = ({
    modelId,
    selectedModel,
    applyToAll,
    defaultTemperature,
    defaultMaxToken,
    defaultTopP,
    defaultFrequency,
    defaultPresencePenalty,
  }: {
    modelId: string;
    selectedModel:string;
    applyToAll: boolean;
    defaultTemperature: number;
    defaultMaxToken: number;
    defaultTopP: number;
    defaultFrequency: number;
    defaultPresencePenalty: number;
  }) => {
    updateModelSettingsMutation.mutate(
      {
        modelId,
        selectedModel,
        applyToAll,
        defaultTemperature,
        defaultMaxToken,
        defaultTopP,
        defaultFrequency,
        defaultPresencePenalty,
      },
      {
        onSuccess: (data: any) => {
          dispatch(
            setParameterForModel({
              key: selectedModel,
              value: {
                temperatureCurrentValue: defaultTemperature,
                maxTokenCurrentValue: defaultMaxToken,
                topPCurrentValue: defaultTopP,
                frequencyCurrentValue: defaultFrequency,
                presencePenaltyCurrentValue: defaultPresencePenalty,
              },
            })
          );
          if (applyToAll) {
            dispatch(
              applyParameterOnAllModels({
                temperatureCurrentValue: defaultTemperature,
                maxTokenCurrentValue: defaultMaxToken,
                topPCurrentValue: defaultTopP,
                frequencyCurrentValue: defaultFrequency,
                presencePenaltyCurrentValue: defaultPresencePenalty,
              })
            );
        }
        dispatch(
          setSnackBarAlert({
            show: true,
            message: "All updates have been saved.",
            alertType: "success",
          })
        );
        dispatch(updateSuccessPopupSavingState(true));
        },
        onError: (error: any) => {
          dispatch(
            setFileError({
              isError: true,
              errorMsg: `${error?.response.data}`,
              reason: "",
            })
          );
        dispatch(updateSuccessPopupSavingState(false));
        },
      }
    );
  };

  return UpdateModelSettingsDefault;
};